import AxiosHelper from "../helper/AxiosHomeCustomer";

class HomeOfficeAxios extends AxiosHelper {
    // eslint-disable-next-line getter-return
    static get axios() {
        // eslint-disable-next-line no-undef
        return AxiosHelper.getInstance()
    }
}

export default HomeOfficeAxios;